import React from 'react';
import {ChekinLogo, cn} from '@chekinapp/ui';

type SplashLogoPlateProps = {
  hostLogo?: string | null;
  upsized?: boolean;
  className?: string;
  children?: React.ReactNode;
};

function SplashLogoPlate({
  hostLogo,
  upsized,
  className,
  children,
}: Readonly<SplashLogoPlateProps>) {
  const [isHostLogoReady, setIsHostLogoReady] = React.useState(false);

  const fadeClassName =
    'col-start-1 row-start-1 transition-opacity [transition-duration:280ms] motion-reduce:transition-none';

  return (
    <div
      className={cn(
        'grid size-[132px] place-items-center',
        upsized && 'desk:size-[156px] kiosko:size-[240px]',
        className,
      )}
    >
      <div
        className={cn(
          'grid size-24 place-items-center',
          upsized && 'desk:size-[112px] kiosko:size-[176px]',
        )}
      >
        <ChekinLogo
          markOnly
          plate
          className={cn(
            fadeClassName,
            '[--chekin-logo-plate-radius:20px] [--chekin-logo-plate-border:transparent] [--logo-mark:52px] [--logo-plate:66px]',
            upsized &&
              'desk:[--logo-mark:62px] desk:[--logo-plate:78px] kiosko:[--chekin-logo-plate-radius:28px] kiosko:[--logo-mark:82px] kiosko:[--logo-plate:104px]',
            hostLogo && isHostLogoReady && 'opacity-0',
          )}
        />
        {hostLogo && (
          <img
            src={hostLogo}
            alt=""
            onLoad={() => setIsHostLogoReady(true)}
            className={cn(
              fadeClassName,
              'max-h-[60px] max-w-[68px] object-contain',
              upsized &&
                'desk:max-h-[86px] desk:max-w-[86px] kiosko:max-h-[120px] kiosko:max-w-[120px]',
              isHostLogoReady ? 'opacity-100' : 'opacity-0',
            )}
          />
        )}
      </div>
      {children}
    </div>
  );
}

export {SplashLogoPlate};
